var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    staticClass: "mdi-card",
    attrs: {
      stripe: "",
      color: "primary",
      "row-key": "id",
      selection: "multiple",
      separator: "horizontal",
      dense: "",
      resource: _vm.resource,
      filter: _vm.filter,
      loading: _vm.loading,
      columns: _vm.columns,
      data: _vm.serverData,
      pagination: _vm.storePagination,
      selected: _vm.selected,
      "rows-per-page-options": [0, 25, 50, 100, 250],
      "visible-columns": _vm.visibleColumnsModel
    },
    on: {
      request: _vm.request,
      "update:pagination": function($event) {
        _vm.storePagination = $event
      },
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:visibleColumns": function($event) {
        _vm.visibleColumnsModel = $event
      },
      "update:visible-columns": function($event) {
        _vm.visibleColumnsModel = $event
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function(props) {
            return _c(
              "div",
              { staticClass: "full-width q-pt-sm q-pb-sm" },
              [
                _c(
                  "transition",
                  {
                    attrs: {
                      mode: "out-in",
                      "enter-active-class": "animated flipInX",
                      "leave-active-class": "animated flipOutX"
                    }
                  },
                  [
                    !_vm.selectedRows.length
                      ? _c(
                          "div",
                          {
                            key: "search-bar",
                            staticClass: "row flex-center gutter-md",
                            staticStyle: { "animation-duration": "0.4s" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("auto-saver", {
                                  attrs: {
                                    duration: 900,
                                    "d-bounce": _vm.handleSearch,
                                    value: _vm.search
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(props) {
                                          return _c("q-input", {
                                            staticClass:
                                              "full-width no-shadow q-body-1",
                                            attrs: {
                                              loading: props.isSaving,
                                              before: [{ icon: "search" }],
                                              placeholder: "Search all records",
                                              color: "secondary",
                                              clearable: "",
                                              "hide-underline": ""
                                            },
                                            on: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                _vm.search = ""
                                              }
                                            },
                                            model: {
                                              value: _vm.search,
                                              callback: function($$v) {
                                                _vm.search = $$v
                                              },
                                              expression: "search"
                                            }
                                          })
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-3 text-right" },
                              [
                                _c("q-table-columns", {
                                  staticClass: "q-body-1 full-width",
                                  attrs: {
                                    label: "Visible Columns",
                                    columns: _vm.columns
                                  },
                                  model: {
                                    value: _vm.visibleColumnsModel,
                                    callback: function($$v) {
                                      _vm.visibleColumnsModel = $$v
                                    },
                                    expression: "visibleColumnsModel"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col text-right" },
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      small: "",
                                      round: "",
                                      icon: "file_download"
                                    }
                                  },
                                  [
                                    _c("q-tooltip", [_vm._v("Download Excel")]),
                                    _c(
                                      "q-popover",
                                      [
                                        _c(
                                          "q-list",
                                          {
                                            attrs: { separator: "", link: "" }
                                          },
                                          [
                                            _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-overlay",
                                                    rawName: "v-close-overlay"
                                                  }
                                                ],
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.handleExcel.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Download CSV")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("q-btn", {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    dense: "",
                                    icon: props.inFullscreen
                                      ? "fullscreen_exit"
                                      : "fullscreen"
                                  },
                                  on: { click: props.toggleFullscreen }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            key: "bulk-update-bar",
                            staticClass: "row flex-center gutter-md",
                            staticStyle: { "animation-duration": "0.4s" }
                          },
                          [
                            !_vm.readonly
                              ? _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("q-select", {
                                      staticClass: "q-mr-sm no-shadow q-body-1",
                                      attrs: {
                                        flat: "",
                                        icon: "edit",
                                        options: [
                                          { label: "", value: "" }
                                        ].concat(_vm.columnOptions),
                                        placeholder:
                                          "Select a field to mass update",
                                        "hide-underline": "",
                                        "inverted-light": "",
                                        color: _vm.inputBgColor
                                      },
                                      model: {
                                        value: _vm.selectedColumnsAction,
                                        callback: function($$v) {
                                          _vm.selectedColumnsAction = $$v
                                        },
                                        expression: "selectedColumnsAction"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.selectedColumnsAction && !_vm.readonly
                              ? _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c(
                                      _vm.batchUpdateComponentColumn.component
                                        .is || "q-input",
                                      _vm._b(
                                        {
                                          tag: "component",
                                          staticClass: "no-shadow q-body-1",
                                          attrs: {
                                            clearable: "",
                                            placeholder:
                                              _vm.batchUpdateComponentColumn
                                                .label,
                                            column:
                                              _vm.batchUpdateComponentColumn,
                                            "hide-underline": "",
                                            "inverted-light": "",
                                            color: _vm.inputBgColor
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.selectedColumnsValue = $event
                                            }
                                          },
                                          model: {
                                            value: _vm.selectedColumnsValue,
                                            callback: function($$v) {
                                              _vm.selectedColumnsValue = $$v
                                            },
                                            expression: "selectedColumnsValue"
                                          }
                                        },
                                        "component",
                                        _vm.batchUpdateComponentColumn.component
                                          .props,
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.readonly
                              ? _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _vm.selectedColumnsAction
                                      ? _c(
                                          "q-btn",
                                          {
                                            staticClass: "no-shadow on-right",
                                            attrs: {
                                              disabled:
                                                _vm.selectedColumnsValue ===
                                                  null ||
                                                _vm.selectedColumnsValue ===
                                                  undefined,
                                              color: "secondary",
                                              push: ""
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleBulkUpdate.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Apply")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "col text-right" },
                              [
                                _vm.trashed
                                  ? _c("q-btn", {
                                      attrs: {
                                        color: "positive",
                                        flat: "",
                                        label: "Restore Selected",
                                        icon: "restore"
                                      },
                                      on: { click: _vm.handleBatchRestore }
                                    })
                                  : _c("q-btn", {
                                      attrs: {
                                        color: "negative",
                                        flat: "",
                                        delete: "",
                                        label: "Delete Selected",
                                        icon: "delete"
                                      },
                                      on: { click: _vm.handleBatchDelete }
                                    })
                              ],
                              1
                            )
                          ]
                        )
                  ]
                )
              ],
              1
            )
          }
        },
        {
          key: "top-row",
          fn: function(props) {
            return _c("filter-bar", {
              attrs: { cols: props.cols, resource: _vm.resource },
              on: {
                change: function($event) {
                  return _vm.request({ pagination: _vm.storePagination })
                }
              }
            })
          }
        },
        _vm._l(_vm.visibleColumns, function(column, columnIndex) {
          return {
            key: "body-cell-" + column.name,
            fn: function(ref) {
              var row = ref.row
              var value = ref.value
              return [
                _c(
                  "q-td",
                  { key: columnIndex, attrs: { align: column.align } },
                  [
                    _c("grid-cell", {
                      attrs: {
                        column: column,
                        row: row,
                        id: row.id,
                        value: value,
                        resource: _vm.resource,
                        trashed: _vm.trashed,
                        "client-route": _vm.clientRoute,
                        readonly: _vm.readonly
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        })
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }